import { useCharlieUser } from 'hooks/useCharlieUser'
import { insightsEqualityViewedEvent } from 'utils/analytics/amplitudeEvents'

import { BarsChart } from './assets/icons/BarsChart'
import { useMenuGroupEquality } from './hooks/useMenuGroupEquality'
import { MenuGroup } from './MenuGroup'

export const MenuGroupEquality = () => {
  const { sidebarItems: sidebarEqualityItem } = useMenuGroupEquality()

  const charlieUser = useCharlieUser()

  if (!sidebarEqualityItem) {
    return null
  }

  return (
    <MenuGroup
      key={sidebarEqualityItem?.text}
      {...sidebarEqualityItem}
      icon={<BarsChart />}
      onClick={() =>
        insightsEqualityViewedEvent(
          { topic: sidebarEqualityItem.text },
          charlieUser
        )
      }
    />
  )
}
